import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ep6collage1 from '../../assets/ep6TN1.jpg';
import ep6collage2 from '../../assets/ep6TN2.jpg';
import ep6collage3 from '../../assets/ep6TN3.jpg';
import ep6collage4 from '../../assets/ep6TN4.jpg';
import ep6collage5 from '../../assets/ep6TN5.jpg';
import ep6collage6 from '../../assets/ep6TN6.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '4rem',
    // paddingBottom: '5rem',
    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.common.background,
      marginTop: 0
    }
  },
  textCont: {
    width: '54%',
    [theme.breakpoints.down('sm')]: {
      width: '72.5%'
    }
  },
  subhead1Cont: {
    marginBottom: '.875rem'
  },
  photoRow: {
    marginTop: '1.8rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px'
    }
  },
  photoCollageCont: {
    width: '81%',
    marginTop: '2rem'
  },
  firstPhoto: {
    width: '48%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '1rem'
    }
  },
  secondPhoto: {
    marginLeft: '1.8rem',
    width: '48%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: '1rem'
    }
  },
  // ------------------------------------
  subhead1: {
    ...theme.typography.subhead1,
    textTransform: 'uppercase',
    color: theme.palette.common.green,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.subhead1
    }
  }
}));

const CollageSection = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container justifyContent="center" className={classes.wrapper}>
      <Grid container justifyContent="center" className={classes.textCont}>
        <Grid item className={classes.subhead1Cont}>
          <Typography className={classes.subhead1}>RYMSKY EVANS AND TEMICA MORTON</Typography>
        </Grid>
        <Grid item>
          <Typography variant={matchesSM ? 'body2' : 'body1'} style={{ textAlign: 'center' }}>
            Despite their different backgrounds and life experiences, Rymsky Evans and Temica Morton
            share a deep, personal commitment to educating and helping protect their communities in
            Jackson, MS, where HIV continues to have a disproportionate impact. For Temica, this
            means using her platform as a nightclub owner to connect the local LGBTQ+ community with
            HIV testing and resources. For Rymsky, it means speaking out to other women like her,
            who may be at greater risk than they realize. But both Temica and Rymsky understand
            that, as Black women in the South, they have the unique opportunity to use their voices
            for change.
          </Typography>
        </Grid>
      </Grid>
      <Grid container className={classes.photoCollageCont}>
        <Grid container direction={matchesSM ? 'column' : undefined} className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep6collage1} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep6collage2} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
        <Grid container className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep6collage3} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep6collage4} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
        <Grid container className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep6collage5} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep6collage6} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CollageSection;
